import Axios from "axios";
//Get publications
export const getAllPublications = async (page, search = '') => {

  const result = await Axios.post(process.env.VUE_APP_BACKEND_URL + `api/publications?page=${page}&search=${search}`);

  return result;
}

export const updatePublications = async () => {
  const result = await Axios.post(process.env.VUE_APP_BACKEND_URL + `api/publications/load`);

  return result;
}

export const updateDimensionsFreight = async (body) => {

  try {
    const result = await Axios.put(process.env.VUE_APP_BACKEND_URL + `api/publications/set-dinamyc-freight`, {
      ...body
    })

    return result;

  } catch (error) {

    throw new Error(error.response.data.msg || 'Error de conexión');
  }

}

export const updateDimensions = async (body) => {
  try {
    const result = await Axios.put(process.env.VUE_APP_BACKEND_URL + `api/publications/set-dimentions`, {
      ...body
    })

    return result;

  } catch (error) {

    throw new Error(error.response.data.msg || 'Error de conexión');
  }
}
